module.exports = __webpack_public_path__ + "img/november-yellow.03ac4169.svg";